import { useTranslation } from 'react-i18next';
import BlogCards from '@components/BlogCards.jsx';

export default function MainBlogArticles() {
    const { t, i18n } = useTranslation();

    function getImage(name) {
        let img = new URL(
            `/src/assets/images/showcase/ea-${name}-${i18n.resolvedLanguage}.png`,
            import.meta.url
        );
        //const imgUrl = await import(`@assets/images/showcase/ea-${name}-${resolvedLanguage}.png`)
        if (img.pathname.includes('undefined')) {
            // fallback to english image
            img = new URL(`/src/assets/images/showcase/ea-${name}-en.png`, import.meta.url);
        }
        return img.href;
    }

    const articles = [
        {
            image: getImage('assist'),
            label: t('dashboardBlog1Label'),
            title: t('dashboardBlog1heading'),
            description: t('dashboardBlog1Text'),
            to: 'https://eye-able.com/assistenzsoftware/'
        },
        {
            image: getImage('audit'),
            label: t('dashboardBlog2Label'),
            title: t('dashboardBlog2heading'),
            description: t('dashboardBlog2Text'),
            to: 'https://eye-able.com/wcag-checker/'
        },
        {
            image: getImage('extension'),
            label: t('dashboardBlog3Label'),
            title: t('dashboardBlog3heading'),
            description: t('dashboardBlog3Text'),
            to: 'https://eye-able.com/arbeitsplatzausstattung-barrierefreiheit/'
        },
        {
            image: getImage('mission'),
            label: t('dashboardBlog4Label'),
            title: t('dashboardBlog4heading'),
            description: t('dashboardBlog4Text'),
            to: 'https://eye-able.com/vision-digitale-barrierefreiheit/'
        }
    ];

    return <BlogCards articles={articles} />;
}
